/* eslint-disable sort-keys */
/* eslint sort-keys: ["error", "asc", {natural: true, caseSensitive: false}] */
const errorMessage = {
  notFoundProjectInFp: '指定したプロジェクトが見つかりません（FP）',
  validation: '入力値が不正です: {0}',
};

export const messagesInJa = {
  // 共通仕様: その他例外
  '/error/global/0000': '不明なエラーが発生しました',
  '/error/global/0001': 'アクセストークンの有効期限が切れています',
  '/error/global/0002': 'サーバー起因の不明なエラーが発生しました',
  '/error/global/0003': 'プロジェクトが見つかりません。必要があれば「たいせいITヘルプデスク（s-net@pub.taisei.co.jp）」に問い合わせください。',
  '/error/global/0004': 'プロジェクトの招待情報がありません。必要があれば「たいせいITヘルプデスク（s-net@pub.taisei.co.jp）」に問い合わせください。',
  '/error/global/0005': 'このプロジェクトは削除されています。必要があれば「たいせいITヘルプデスク（s-net@pub.taisei.co.jp）」に問い合わせください。',
  '/error/global/0006': '表示可能なプロジェクトがありません。必要があれば「たいせいITヘルプデスク（s-net@pub.taisei.co.jp）」に問い合わせください。',
  '/error/global/0007': 'このプロジェクト（サービス）は削除されています。必要があれば「たいせいITヘルプデスク（s-net@pub.taisei.co.jp）」に問い合わせください。',
  '/error/global/0008': 'このプロジェクト（サービス）は閉鎖されています。必要があれば「たいせいITヘルプデスク（s-net@pub.taisei.co.jp）」に問い合わせください。',
  // [図面API](002001) Myショートカット検索
  '/error/S-CAPI-DDMS-002001/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-002001/1001': errorMessage.notFoundProjectInFp,
  // (001001) プロジェクト情報一覧
  '/error/S-CAPI-FP-001001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001001/0002': errorMessage.notFoundProjectInFp,
  // (001002) デフォルトプロジェクト取得
  '/error/S-CAPI-FP-001002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001002/0002': 'プロジェクト切替から閲覧したいプロジェクトを選択してください。',
  '/error/S-CAPI-FP-001002/0003': 'プロジェクトの招待情報がありません。',
  '/error/S-CAPI-FP-001002/0004': '表示可能なプロジェクトがありません。',
  '/error/S-CAPI-FP-001002/0005': 'このプロジェクトはサービス準備中です。',
  // (001003) デフォルトプロジェクト更新
  '/error/S-CAPI-FP-001003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001003/0002': errorMessage.notFoundProjectInFp,
  // (001004) プロジェクト詳細取得
  '/error/S-CAPI-FP-001004/0001': errorMessage.validation,
  // (001005) プロジェクト招待者取得
  '/error/S-CAPI-FP-001005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001005/0002': errorMessage.notFoundProjectInFp,
  // (001006) プロジェクト情報取得
  '/error/S-CAPI-FP-001006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001006/0002': errorMessage.notFoundProjectInFp,
  // (001008) 役割追加更新
  '/error/S-CAPI-FP-001008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001008/0002': errorMessage.notFoundProjectInFp,
  // (001009) 未使用役割一覧取得
  '/error/S-CAPI-FP-001009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001009/0002': errorMessage.notFoundProjectInFp,
  // (002002) レイアウト更新
  '/error/S-CAPI-FP-002002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002002/0004': '指定したレイアウトが見つかりません',
  // (002004) レイアウト追加
  '/error/S-CAPI-FP-002004/0001': errorMessage.validation,
  // (002005) レイアウト一覧取得
  '/error/S-CAPI-FP-002005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002005/0002': 'このプロジェクトで表示可能なレイアウトがありません。必要があれば「たいせいITヘルプデスク（s-net@pub.taisei.co.jp）」に問い合わせください。',
  // (002006) デフォルトレイアウト取得
  '/error/S-CAPI-FP-002006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002006/0002': errorMessage.notFoundProjectInFp,
  // (002007) デフォルトレイアウト更新
  '/error/S-CAPI-FP-002007/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002007/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002007/0003': '指定したレイアウトが見つかりません',
  // (002008) 管理者用レイアウト一覧取得
  '/error/S-CAPI-FP-002008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002008/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002008/0003': '管理者用レイアウトを編集する権限がありません',
  // (002009) レイアウト名変更
  '/error/S-CAPI-FP-002009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002009/0002': errorMessage.notFoundProjectInFp,
  // (002010) レイアウト削除
  '/error/S-CAPI-FP-002010/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002010/0002': errorMessage.notFoundProjectInFp,
  // (004001) メインメニュー詳細取得
  '/error/S-CAPI-FP-004001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-004001/0002': errorMessage.notFoundProjectInFp,
  // (004003) 管理者用メインメニュー詳細取得
  '/error/S-CAPI-FP-004003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-004003/0002': '管理者用メインメニューを編集する権限がありません',
  // (005001) ダウンロード履歴検索結果取得
  '/error/S-CAPI-FP-005001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005001/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005001/0003': 'ダウンロード履歴を取得するデータソース（API）が見つかりません',
  // (005002) 新着通知検索結果取得
  '/error/S-CAPI-FP-005002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005002/0003': '新着情報を取得するデータソース（API）が見つかりません',
  // (005003) 保存済み検索条件詳細取得
  '/error/S-CAPI-FP-005003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005003/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005003/0003': '指定した検索条件が見つかりません',
  // (005004) 新着通知既読更新
  '/error/S-CAPI-FP-005004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005004/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005004/0003': '既読にできませんでした',
  // (006001) 保存済み検索条件一覧取得
  '/error/S-CAPI-FP-006001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006001/0002': errorMessage.notFoundProjectInFp,
  // (006002) 保存済み検索条件取得
  '/error/S-CAPI-FP-006002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-006002/0003': '指定した検索条件が見つかりません',
  // (006004) 保存済み検索条件追加更新
  '/error/S-CAPI-FP-006004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006004/0002': errorMessage.notFoundProjectInFp,
  // (006005) 保存済み検索条件削除
  '/error/S-CAPI-FP-006005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006005/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-006005/0003': '指定した検索条件が見つかりません',
  '/error/S-CAPI-FP-006005/0004': '指定した検索条件は、ガジェットで使用済みのため削除できません',
  // (007001) 拡張属性定義一覧取得
  '/error/S-CAPI-FP-007001/0001': errorMessage.validation,
  // (007002) ユーザー拡張属性定義削除
  '/error/S-CAPI-FP-007002/0001': errorMessage.validation,
  // (007003) ユーザー拡張属性定義登録
  '/error/S-CAPI-FP-007003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007003/0002': '拡張属性定義の登録に失敗しました',
  // (007004) ユーザー拡張属性定義更新
  '/error/S-CAPI-FP-007004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007004/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-007004/0003': '拡張属性定義の更新に失敗しました',
  // (007005) 拡張属性定義関連内容タグ一覧取得
  '/error/S-CAPI-FP-007005/0001': errorMessage.validation,
  // (007006) 拡張属性区分値一括登録
  '/error/S-CAPI-FP-007006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007006/0002': '拡張属性定義が見つかりません',
  '/error/S-CAPI-FP-007006/0003': '拡張属性定義の区分値登録に失敗しました',
  // (007007) 拡張属性区分値一括更新
  '/error/S-CAPI-FP-007007/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007007/0002': '拡張属性定義が見つかりません',
  '/error/S-CAPI-FP-007007/0003': '更新対象の区分値が見つかりません',
  '/error/S-CAPI-FP-007007/0004': '拡張属性定義の区分値更新に失敗しました',
  // (007008) 拡張属性定義関連内容タグ一括更新
  '/error/S-CAPI-FP-007008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007008/0002': '拡張属性定義関連内容タグの更新に失敗しました',
  // (007009) 拡張属性区分値削除
  '/error/S-CAPI-FP-007009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007009/0002': '拡張属性定義が見つかりません',
  '/error/S-CAPI-FP-007009/0003': '更新対象の区分値が見つかりません',
  '/error/S-CAPI-FP-007009/0004': '拡張属性定義の区分値削除に失敗しました',
  // (008001) 内容タグツリー取得
  '/error/S-CAPI-FP-008001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-008002/0001': '指定したプロジェクトのアクセス権限がありません',
  // (009001) ラック検索
  '/error/S-CAPI-FP-009001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-009001/0002': '拡張属性に誤りがあります',
  // (010001) 内容タグViewパターン一覧取得
  '/error/S-CAPI-FP-010001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-010001/0002': errorMessage.notFoundProjectInFp,
  // (011001) データラック一覧取得
  '/error/S-CAPI-DDMS-051001/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-051001/0002': errorMessage.validation,
  // (011001) ファイルダウンロード(購読制御入り)
  '/error/S-CAPI-DDMS-010003/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-010003/0002': errorMessage.validation,
  'dataRackSearch.error': '{0}の情報取得に失敗しました',
  '/error/S-CAPI-DDMS-010003/0006': '新着通知が見つかりません',
  'addSearchCriteriaButton.label': '検索条件追加',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.READ': '参照',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.READ_WRITE': '更新',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.undefined': '不明',
  'DataBoxModelApprovalTypeEnum.APPROVED': '承認済み',
  'DataBoxModelApprovalTypeEnum.APPROVING': '承認中',
  'DataBoxModelApprovalTypeEnum.DENIAL': '否認',
  'DataBoxModelApprovalTypeEnum.PARTIAL_APPROVAL': '部分承認',
  'DataBoxModelApprovalTypeEnum.UNAPPROVED': '未承認',
  'DataBoxModelApprovalTypeEnum.undefined': '',
  'dialog.apply': '適用',
  'dialog.cancel': 'キャンセル',
  'dialog.close': '閉じる',
  'dialog.delete.message': '削除すると復元できませんのでご注意ください。',
  'dialog.delete.title': '本当に削除しますか？',
  'dialog.editAttributeValueName.label.name': '表示名',
  'dialog.editGadgetImage.label.color': '背景色',
  'dialog.editGadgetImage.label.image': '画像URL',
  'dialog.editGadgetImage.message': '選択したガジェットの背景画像のURLを指定してください。',
  'dialog.editGadgetImage.title': '背景画像を適用します',
  'dialog.editGadgetName.title': 'ガジェットの表示名を編集します',
  'dialog.layoutAdd.description': 'レイアウト名を入力してください。',
  'dialog.layoutAdd.title': 'レイアウトを追加します',
  'dialog.layoutEdit.message.confirm': '入力した内容が失われますがよろしいですか？',
  'dialog.layoutEdit.message.leave': 'ページを移動しようとしています。',
  'dialog.layoutEdit.title': '離脱確認',
  'dialog.layoutEditChange.message.change': 'レイアウトを切り替えようとしています。',
  'dialog.layoutEditChange.message.confirm': '入力した内容が失われますがよろしいですか？',
  'dialog.layoutEditChange.title': 'レイアウト切替確認',
  'dialog.layoutNameEdit.description': 'レイアウト名を入力してください。',
  'dialog.layoutNameEdit.title': 'レイアウト名を変更します',
  'dialog.leaveLayoutEdit.message': '現在編集中の内容を保存してファイル検索画面へ遷移しますがよろしいでしょうか？',
  'dialog.leaveLayoutEdit.title': 'ファイル検索画面へ遷移します',
  'dialog.ok': 'OK',
  'dialog.roleAdd.message': '役割コードと役割名を入力してください。',
  'dialog.roleAdd.note': '既に存在する役割コードの場合は上書きされます。',
  'dialog.roleAdd.title': '役割を追加します',
  'dialog.roleChanger.title': 'レイアウト役割変更',
  'dialog.roleChanger.unusedRole': '未使用の役割',
  'downloadHistory.contentTagName': 'フォルダ名',
  'downloadHistory.dataRackName': 'ファイル名',
  'downloadHistory.downloadAt': 'ダウンロード日時',
  'extensiveAttribute.availableFlag': '使用可能',
  'extensiveAttribute.commonManagementFlag': '種類',
  'extensiveAttribute.contentTags': '拡張属性付与フォルダ',
  'extensiveAttribute.extensiveAttributeDefinition': '拡張属性定義',
  'extensiveAttribute.extensiveAttributeDefinitionName': '拡張属性定義名',
  'extensiveAttribute.extensiveAttributeValue': '区分値',
  'extensiveAttribute.valueEditAllowFlag': '区分値編集可能',
  'extensiveAttribute.valueType': '拡張属性型',
  'ExtensiveAttributeModel.availableFlag.label': '使用可能',
  'ExtensiveAttributeModel.commonManagementFlag.label': '種類',
  'ExtensiveAttributeModel.commonManagementFlag.label.COMMON': '標準',
  'ExtensiveAttributeModel.commonManagementFlag.label.undefined': '不明な種類',
  'ExtensiveAttributeModel.commonManagementFlag.label.USER': 'ユーザー',
  'ExtensiveAttributeModel.descriptionText.label': '説明',
  'ExtensiveAttributeModel.extensiveAttributeDefinitionName.label': '属性名',
  'ExtensiveAttributeModel.valueType.label': '値型',
  'ExtensiveAttributeModel.valueType.label.BOOL': '真偽値',
  'ExtensiveAttributeModel.valueType.label.DATE': '日付',
  'ExtensiveAttributeModel.valueType.label.DATETIME': '日付時刻',
  'ExtensiveAttributeModel.valueType.label.MULTI_SELECT': '区分値(複数選択)',
  'ExtensiveAttributeModel.valueType.label.NUMBER': '数値',
  'ExtensiveAttributeModel.valueType.label.SINGLE_SELECT': '区分値(単一選択)',
  'ExtensiveAttributeModel.valueType.label.TEXT': '文字',
  'ExtensiveAttributeModel.valueType.label.WHOLE_NUMBER': 'ゼロを含む正の整数',
  'ExtensiveAttributeModel.valueType.label.undefined': '不明な種類',
  'ExtensiveAttributeValueModel.common_management_flag.COMMON': '標準',
  'ExtensiveAttributeValueModel.common_management_flag.undefined': '不明な種類',
  'ExtensiveAttributeValueModel.common_management_flag.USER': 'ユーザー',
  'field.displayName.en': '表示名（英語）',
  'field.displayName.ja': '表示名',
  'field.roleCode': '役割コード',
  'FpCustomColumnMenu.label.save': '保存',
  'FpDownloadHistoryGrid.message': '直近90日間の履歴を表示しています',
  'FpExtensiveAttribute.commonManagementFlag.common': '標準',
  'FpExtensiveAttribute.commonManagementFlag.user': 'ユーザー',
  'FpExtensiveAttribute.flag.true': '可',
  'FpExtensiveAttribute.header.edit': '編集',
  'FpExtensiveAttribute.header.new': '新規追加',
  'FpExtensiveAttribute.valueType.bool': '真偽値',
  'FpExtensiveAttribute.valueType.date': '日付',
  'FpExtensiveAttribute.valueType.datetime': '日付時刻',
  'FpExtensiveAttribute.valueType.multiSelect': '複数選択型区分値',
  'FpExtensiveAttribute.valueType.number': '数値',
  'FpExtensiveAttribute.valueType.singleSelect': '単選択型区分値',
  'FpExtensiveAttribute.valueType.text': '文字',
  'FpExtensiveAttribute.valueType.wholeNumber': 'ゼロを含む正の整数',
  'FpExtensiveAttributeGrid.filter.hint': '拡張属性名で絞り込む',
  'FpExtensiveAttributesAdd.title': '拡張属性定義追加',
  'FpExtensiveAttributesContentTagManagement.title': '拡張属性付与フォルダ編集',
  'FpExtensiveAttributesEdit.error': '編集できない拡張属性です',
  'FpExtensiveAttributesEdit.title': '拡張属性定義編集',
  'FpExtensiveAttributesFolderSelect.confirm.body': '拡張属性付与フォルダ編集を確定します。よろしいですか？',
  'FpExtensiveAttributesFolderSelect.filter.label': 'フォルダ名で絞り込む',
  'FpExtensiveAttributesValuesEdit.error': '編集できない区分値です',
  'FpExtensiveAttributesValuesEdit.success': '変更内容を保存しました',
  'FpExtensiveAttributesValuesEdit.title': '拡張属性区分値編集',
  'FpExtensiveAttributesValuesEdit.warning': '変更はありませんでした',
  'FpExtensiveAttributeValueDetail.delete.description': '削除すると復元できませんのでご注意ください。',
  'FpExtensiveAttributeValueDetail.delete.title': '選択した区分値を削除します',
  'FpFileSearch.criteria-save-as': '検索条件に名前を付けて保存',
  'FpFileSearch.label.clear': 'クリア',
  'FpFileSearch.label.save': '保存',
  'FpFileSearch.notification.project-not-found': '別プロジェクトの検索条件が指定されました.',
  'FpFileSearch.notification.save-criteria.error': '検索条件の保存実行時にエラーが発生しました',
  'FpFileSearch.notification.save-criteria.success': '検索条件を保存しました',
  'FpFileSearch.notification.search.error': '検索実行時にエラーが発生しました.',
  'FpFileSearchCommonCriteria.label.created-at': '作成日',
  'FpFileSearchCommonCriteria.label.creator': '作成者',
  'FpFileSearchCommonCriteria.label.file-name': 'ファイル名',
  'FpFileSearchCriteria.label.back': '戻る',
  'FpFileSearchCriteria.label.clear': 'クリア',
  'FpFileSearchCriteria.label.save': '検索条件を保存',
  'FpFileSearchCriteria.label.search': '検索',
  'FpFileSearchCriteria.label.search-criteria': '詳細検索条件',
  'FpFileSearchCriteria.search-criteria-advanced': '詳細検索条件（複数指定した場合はOR条件で適用されます）',
  'FpFileSearchCriteria.criteria-required': '検索するには１件以上の検索条件を入力して下さい',
  'FpFileSearchResult.header.details.title': 'ファイル詳細',
  'FpFileSearchWrapper.criteria.not-found': '指定された検索条件が見つかりません',
  'FpFolderSearch.filter.label': 'フォルダ名で絞り込む',
  'FpFolderSearch.notification.warn.view-pattern-not-found': 'VIEWパターンが取得できませんでした。',
  'FpGadgetButtonGroup.title': 'テンプレートからコピーされたガジェットは編集できません',
  'FpLayoutCopy.destination-list.chip.create': '新規',
  'FpLayoutCopy.destination-list.chip.template': 'テンプレート',
  'FpLayoutCopy.destination-list.selected-project.count': 'プロジェクト 選択中',
  'FpLayoutCopy.destination-type.copied': '通常プロジェクトを表示する',
  'FpLayoutCopy.destination-type.template': 'テンプレートプロジェクトを表示する',
  'FpLayoutCopy.notification.success': 'レイアウトコピーが完了しました',
  'FpLayoutCopy.section-title.destinations': 'コピー先レイアウト選択',
  'FpLayoutCopyPreview.preview-type.copied': 'コピー結果',
  'FpLayoutCopyPreview.preview-type.destination': 'コピー先',
  'FpLayoutCopyPreview.preview-type.source': 'コピー元',
  'FpLayoutEdit.role_view.title': '本社支店役割一覧',
  'FpMainMenuEditFileSearch.description': '{0}で使用しているメインメニューを編集します',
  'FpMainMenuEditFileSearch.dialog.title': 'ファイル',
  'FpMainMenuEditFileSearch.label.add': '追加',
  'FpMainMenuEditRoleList.title': '表示可能な役割一覧',
  'FpMainMenuEditSearchCriteria.title': 'ファイル検索',
  'FpMainMenuEditSplitter.custom.label': 'カスタム項目',
  'FpMainMenuEditSplitter.etc.file': 'ファイル追加',
  'FpMainMenuEditSplitter.etc.folder': 'フォルダ追加',
  'FpMainMenuEditSplitter.etc.label': 'その他',
  'FpMainMenuEditSplitter.normal.label': '基本アイテム',
  'FpMainMenuEditSplitter.normal.subTitle': '小見出し',
  'FpMainMenuEditSplitter.normal.text': 'テキスト',
  'FpMainMenuEditSplitter.normal.url': 'URL',
  'FpMainMenuItemAddAction.button': '追加',
  'FpProjectList.footer.exists': '{0}件のプロジェクトが見つかりました',
  'FpProjectList.footer.notFound': 'プロジェクトはありません',
  'FpProjectSplitter.filter.hint': 'プロジェクトを絞り込む',
  'FpProjectTree.show-all': '全て表示',
  'FpRole.delete.description': '削除すると復元できませんのでご注意ください。',
  'FpRole.delete.title': '本当に削除しますか？',
  'FpRoleSelectGroup.button.all': 'すべて',
  'FpSearchCriteriaCard.delete-confirm.body': '削除すると復元できません。',
  'FpSearchCriteriaCard.delete-confirm.title': '選択した検索条件を削除します',
  'FpSearchCriteriaCard.disabled.title': 'テンプレートからコピーされた検索条件は編集できません',
  'FpSearchCriteriaCard.layout-list': '以下のレイアウトで使用されています',
  'FpSearchCriteriaCard.not-in-use': '未使用',
  'FpSearchCriteriaCard.unmodifiable-alert-dialog.body': '検索条件を参照しているレイアウトが存在するため削除できません。ガジェットを編集し参照を解除してください。',
  'FpSearchCriteriaCard.unmodifiable-alert-dialog.title': '選択した検索条件は削除できません',
  'FpSearchCriteriaManagement.delete.error': '削除処理でエラーが発生しました。再度実行してください。',
  'FpSearchCriteriaManagement.delete.success': '検索条件を削除しました。',
  'FpSearchCriteriaManagement.filter.hint': '検索条件名で絞り込む',
  'FpSearchCriteriaManagement.no-criteria': '検索条件はありません',
  'FpSearchCriteriaManagement.title': '検索条件管理',
  'FpSearchCriteriaManagement.title.description': 'このプロジェクトで管理している検索条件を編集します',
  'FpSearchCriteriaSave.dialog.title': '名前を付けて保存',
  'FpPortal.DownloadError': '{0}のダウンロードに失敗しました',
  'FpPortal.DownloadStatusError': '{0}はダウンロード可能な状態ではありません',
  'gadgetContents.empty.label': 'データがありません',
  'gadgetContents.warning.label': '編集中は表示できません',
  'gadgetSelect.download.description': 'プロジェクト内でダウンロードされたファイル',
  'gadgetSelect.download.label': 'ダウンロード履歴',
  'gadgetSelect.mainMenu.description': '業務に必要なフォルダ・ファイルへのショートカット',
  'gadgetSelect.mainMenu.label': 'メインメニュー',
  'gadgetSelect.myShortcut.description': '個人が追加するリンク集',
  'gadgetSelect.myShortcut.label': 'Myショートカット',
  'gadgetSelect.newArrival.description': 'プロジェクト内のファイルの新着情報',
  'gadgetSelect.newArrival.label': '新着情報',
  'gadgetSelect.searchCriteria.description': '保存済みの検索条件の検索結果',
  'gadgetSelectGroup.label': '適用可能なガジェット',
  'grid.noRecords': 'データがありません',
  'header.title': 'ファイルポータル',
  'header.userInfo': '{0}さんでログイン中です',
  'label.access-level': 'アクセス権限',
  'label.add': '追加',
  'label.approval_type': '承認区分',
  'label.back': '戻る',
  'label.cancel': 'キャンセル',
  'label.changing': '変更中',
  'label.create_company_name': '作成企業',
  'label.created-at': '作成日時',
  'label.creater': '作成者',
  'label.data_item_count': 'データ項目数',
  'label.delete': '削除',
  'label.details': '詳細',
  'label.edit': '編集',
  'label.file-name': 'ファイル名',
  'label.folder': 'フォルダ',
  'label.folder-name': 'フォルダ名',
  'label.folder-search': 'フォルダ検索',
  'label.gadget-name': 'ガジェット名',
  'label.gadget-type': 'ガジェットタイプ',
  'label.gadget-type.GT1': 'メインメニュー',
  'label.gadget-type.GT2': 'オリジナル検索条件',
  'label.gadget-type.GT3': 'ダウンロード履歴',
  'label.gadget-type.GT4': '新着情報',
  'label.gadget-type.GT5': 'Myショートカット',
  'label.headquarters_role.change': '本社支店役割変更',
  'label.headquarters_role.show': '本社支店役割表示',
  'label.preview': 'プレビュー',
  'label.project_status.CLOSED': '完了',
  'label.project_status.DELETE': '削除',
  'label.project_status.FROZEN': '凍結',
  'label.project_status.OPEN': '利用中',
  'label.reload': '再読み込み',
  'label.role': '役割名',
  'label.role-code': '役割コード',
  'label.role-list': '役割一覧',
  'label.role-name': '役割名',
  'label.save': '保存',
  'label.updated-at': '更新日時',
  'label.updater': '更新者',
  'label.download': 'ダウンロード',
  'label.mark_as_read': '既読にする',
  'label.view': 'ビュー',
  'layoutEdit.cancel.label': 'キャンセル',
  'layoutEdit.changeRole.label': 'PJ役割変更',
  'layoutEdit.preview.back': '編集',
  'layoutEdit.preview.label': 'プレビュー',
  'layoutEdit.save.label': '保存',
  'layoutEdit.warning.label': 'テンプレートレイアウトを編集中です',
  'layoutPreview.note': 'プレビュー表示中',
  'layoutRole.addLayout': 'レイアウト追加',
  'layoutRole.addRole': '新規役割追加',
  'layoutRole.copy': '別プロジェクトへコピー',
  'layoutRole.deleteLayout': 'レイアウト削除',
  'layoutRole.editLayout': 'レイアウト編集',
  'layoutRole.editName': 'レイアウト名変更',
  'layoutRole.unusedRole': '未使用の役割',
  'link.attr': '拡張属性定義管理',
  'link.layout': 'レイアウト管理',
  'link.projectDetail': 'プロジェクト詳細',
  'link.projectSwitch': 'プロジェクト切替',
  'link.search': '検索条件管理',
  'link.top': 'ポータル',
  logout: 'ログアウト',
  'mainMenuEditGridColumnProps.displayNameEn': '表示名（英語）',
  'mainMenuEditGridColumnProps.displayNameJa': '表示名',
  'mainMenuEditGridColumnProps.type': '種別',
  'mainMenuGrid.button.delete': '削除',
  'mainMenuGrid.button.edit': '編集',
  'mainMenuGrid.button.preview': 'プレビュー',
  'mainMenuItemTypeCode.type.MT1': '小見出し',
  'mainMenuItemTypeCode.type.MT2': 'テキスト',
  'mainMenuItemTypeCode.type.MT3': 'URL',
  'mainMenuItemTypeCode.type.MT4': '保存済み検索条件',
  'mainMenuItemTypeCode.type.MT5': 'フォルダ',
  'mainMenuItemTypeCode.type.MT6': 'ファイル',
  'myshortcut.error.model': '想定していない返却値です',
  'newArrivalNotification.content_tag_name': 'フォルダ名',
  'newArrivalNotification.data_rack_name': 'ファイル名',
  'newArrivalNotification.notification_content': '通知内容',
  'newArrivalNotification.read': '既読',
  'newArrivalNotification.source_user_name_without_middle_name': '更新者',
  'newArrivalNotification.source_xgrab_user_company_name': '更新企業',
  'newArrivalNotification.unread': '未読',
  'newArrivalNotification.updated_at': '更新日時',
  'newArrivalNotification.loading': '読み込み中...',
  'notification.extensiveAttributeDefinitionCreate.success': '編集内容を保存しました',
  'notification.extensiveAttributeDefinitionUpdate.success': '編集内容を保存しました',
  'notification.layoutCreate.success': 'レイアウトを登録しました。',
  'notification.layoutDelete.success': 'レイアウトを削除しました。',
  'notification.layoutNameUpdate.success': 'レイアウト名を変更しました。',
  'notification.layoutUpdate.error': 'レイアウト更新に失敗しました: {0}',
  'notification.layoutUpdate.success': 'レイアウトを更新しました。',
  'notification.putExtensiveAttributesAppliedContentTags.error': '選択した内容タグへの拡張属性付与に失敗しました',
  'notification.putExtensiveAttributesAppliedContentTags.success': '選択した内容タグに拡張属性を付与しました',
  'notification.roleCreate.success': '役割を登録しました。',
  'notification.roleDelete.success': '役割を削除しました。',
  'notification.download.waiting': '待機中',
  'page.description.extensiveAttribute': '拡張属性やフォルダとの紐付けを編集します',
  'page.description.layout-copy': 'コピー先を選択しレイアウトをコピーします。',
  'page.description.layoutRole': 'プロジェクトのレイアウトと役割を管理します。',
  'page.description.mainMenuEditList': '{0}で使用しているメインメニューを編集します',
  'page.description.projectSelect': '選択したプロジェクトに表示を切り替えます',
  'page.title.extensiveAttribute': '拡張属性管理',
  'page.title.layout-copy': 'レイアウトコピー',
  'page.title.layout-copy-preview': 'レイアウトコピー プレビュー',
  'page.title.layoutRole': 'レイアウト管理',
  'page.title.mainMenuEditList': '{0}の編集',
  'page.title.projectSelect': 'プロジェクト切替',
  'project.list.title': 'プロジェクト一覧',
  'projectDetail.description': '{0}の詳細です',
  'projectDetail.label.address': '住所',
  'projectDetail.label.area': '地域',
  'projectDetail.label.branchObjectName': '本支店名',
  'projectDetail.label.businessTypeName': '事業種別名',
  'projectDetail.label.constructionPlaceAddress': '施工場所・住所',
  'projectDetail.label.endedOn': '終了日',
  'projectDetail.label.faxNumber': 'FAX番号',
  'projectDetail.label.ownerCompanyName': 'オーナー企業名',
  'projectDetail.label.ProjectGroupCompletedAt': '案件グループ完了日',
  'projectDetail.label.projectGroupName': '案件グループ名',
  'projectDetail.label.projectGroupStatus': '案件グループステータス',
  'projectDetail.label.projectName': 'プロジェクト名',
  'projectDetail.label.projectStatus': 'プロジェクトステータス',
  'projectDetail.label.projectType': 'プロジェクト種別名',
  'projectDetail.label.responsiblePersonName': '責任者名',
  'projectDetail.label.startedOn': '開始日',
  'projectDetail.label.telNumber': '電話番号',
  'projectDetail.title': 'プロジェクト詳細',
  'projectDetail.title.info': 'プロジェクト情報',
  'projectDetail.title.invitee': 'プロジェクトメンバー',
  'searchResult.contentTagName': 'フォルダ名',
  'searchResult.dataItemCount': 'データ項目数',
  'searchResult.rackName': 'ファイル名',
  'searchResult.sequenceNumber': '最新バージョン',
  'searchResult.updateCompanyName': '更新企業',
  'searchResult.updatedAt': '更新日時',
  'searchResult.updateUserName': '更新者',
  'service.file': 'ファイル',
  'service.picture': '写真',
  'service.title': 'ファイルポータル',
  'service.pjInvite': 'プロジェクト招待',
  'service.groupManager': 'グループ マネージャー',
  'service.spiderPlus': 'SPIDERPLUS リンク',
  'service.exchangeManager': 'Exchangeマネージャー',
  'update.confirm.title': '更新確認',
  'validation.formatRegExp.message': '[{0}]形式で入力してください',
  'validation.max.message': '{0}文字以内で入力してください',
  'validation.min.message': '{0}文字以上で入力してください',
  'validation.range.message': '{0}～{1}の間で入力してください',
  'validation.required.message': '必須項目です',
  'validation.uri.message': 'http:、https:、ftpURL:のいずれかで始まる値で入力してください',
  'validation.integer.message': '整数で入力してください',
  'notification.projectRead.warning': '招待されているプロジェクトがありません。',
  'fileServiceLeftPaincontrolType.message': 'このリンクを開く際にフォルダ一覧（左ペイン）を開く',
};
